<bx-modal>
  <bx-modal-header
    [title]="ref.data.title"
    [paddingBottom]="true"
    [closeButton]="{ ariaLabel: 'system.aria.close' | translate }"
    (closeClick)="ref.close()"
  >
  </bx-modal-header>

  <bx-modal-content>
    {{ ref.data.message }}
  </bx-modal-content>

  <bx-modal-actions
    [primaryButton]="confirmButtonText()"
    [secondaryButton]="cancelButtonText()"
    (primaryClick)="ref.close(true)"
    (secondaryClick)="ref.close(false)"
  ></bx-modal-actions>
</bx-modal>
